var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-file-download"},[_vm._t("default",null,null,{
      loading: _vm.$wait.is('downloading inline file'),
      download: _vm.download,
      error: _vm.$err.has('error while downloading inline file')
    })],2)}
var staticRenderFns = []

export { render, staticRenderFns }